import { render, staticRenderFns } from "./jingfengPacslist.vue?vue&type=template&id=08e095df&scoped=true"
import script from "./jingfengPacslist.vue?vue&type=script&lang=js"
export * from "./jingfengPacslist.vue?vue&type=script&lang=js"
import style0 from "./jingfengPacslist.vue?vue&type=style&index=0&id=08e095df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e095df",
  null
  
)

export default component.exports